import axios from 'axios';
const http = axios.create();
http.defaults.baseURL = process.env.REACT_APP_API_URL;

// Get fresh token for EVERY request (not just once at module load)
http.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token') || '';
        if (token) {
            config.headers['Authorization'] = token;
        }
        return config;
    },
    error => Promise.reject(error)
);

http.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            localStorage.clear();
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default http;